import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Body } from '../DefaultStyles/Details';
import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';
import WidgetHeader from '../Widget/WidgetHeader';

import {
    Container,
    FormHeader,
    ParentOrg,
    Title,
    VolunteerFormWrapper,
    volunteerMatchLogoURL
} from '../../components/Volunteer/Shared';

import TransitionContainer from '../../components/Transition/TranstionContainer';
import VolunteerForm from '../../components/Volunteer/VolunteerForm';

import { goBack, onSubmitVolunteerForm } from './actions';
import {
    getExitingCardProps,
    onGoToNextCard,
    setExitingCardProps,
    widgetBounce
} from '../Widget/actions';

import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { cacheFormData } from '../../utils/formCaching/actions';
import { getActionCompletedTime } from '../../utils/actionTiming';
import { handleSkippingEndCard } from '../../utils/handleSkippingEndCard';

import { CardTypes } from '../../utils/enums';

const VolunteerDetails = props => (
    <TransitionContainer
        isSubmitting={props.isSubmitting}
        isBackTransition={props.isBackTransition}
    >
        <Overlay />
        <OverlayPublisher />
        <OverlayPartner transitionType="right-to-left" />
        <OverlayPartner
            logoIsSmall={false}
            transitionType="right-to-left"
            logo={volunteerMatchLogoURL}
            name={'About VolunteerMatch'}
            description={
                "We believe everyone should have the chance to make a difference. That's why we make it easy for good people and good causes to connect. We've connected millions of people with a great place to volunteer and helped tens of thousands of organizations better leverage volunteers to create real impact."
            }
        />
        <Body>
            <WidgetHeader />
            <Container>
                <VolunteerFormWrapper>
                    <FormHeader>
                        <Title>Volunteer Signup</Title>
                    </FormHeader>
                    <ParentOrg>{props.volunteerOpportunity.parentOrg.name}</ParentOrg>
                    <VolunteerForm
                        volunteerOpportunity={props.volunteerOpportunity}
                        onBack={() => {
                            if (!props.bounceDismissed) {
                                props.widgetBounce(
                                    true,
                                    props.widgetRequestId,
                                    props.articleUrl,
                                    props.currentFormValues,
                                    props.actionIdentifier
                                );
                            } else {
                                props.setExitingCardProps(
                                    'volunteer',
                                    props,
                                    props.activeAction
                                );
                                props.goBack();
                            }
                        }}
                        onSubmit={() => {
                            props.cacheFormData(props.volunteerFormData);
                            props.setExitingCardProps(
                                'volunteer',
                                props,
                                props.activeAction
                            );
                            if (props.skipEndCard && !!props.nextAction) {
                                props.handleSkippingEndCard(
                                    props.nextAction,
                                    props.cards,
                                    props.onGoToNextCard
                                );
                            }
                            props.onSubmitVolunteerForm(
                                props.volunteerOpportunity,
                                props.volunteerFormData,
                                props.apiRequestData,
                                props.actionCompletedTime(),
                                props.isMultiCard,
                                props.actionIdentifier,
                                props.skipEndCard && !!props.nextAction
                            );
                        }}
                    />
                </VolunteerFormWrapper>
            </Container>
        </Body>
    </TransitionContainer>
);

VolunteerDetails.propTypes = {
    actionCompletedTime: PropTypes.func,
    actionIdentifier: PropTypes.string.isRequired,
    activeAction: PropTypes.object.isRequired,
    apiRequestData: PropTypes.object.isRequired,
    articleUrl: PropTypes.string.isRequired,
    bounceDismissed: PropTypes.bool.isRequired,
    cacheFormData: PropTypes.func.isRequired,
    cards: PropTypes.array.isRequired,
    currentFormValues: PropTypes.object,
    goBack: PropTypes.func.isRequired,
    handleSkippingEndCard: PropTypes.func.isRequired,
    isBackTransition: PropTypes.bool.isRequired,
    isMultiCard: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    nextAction: PropTypes.object,
    onGoToNextCard: PropTypes.func.isRequired,
    onSubmitVolunteerForm: PropTypes.func.isRequired,
    setExitingCardProps: PropTypes.func.isRequired,
    skipEndCard: PropTypes.bool.isRequired,
    volunteerFormData: PropTypes.object.isRequired,
    volunteerOpportunity: PropTypes.object.isRequired,
    widgetBounce: PropTypes.func.isRequired,
    widgetRequestId: PropTypes.string.isRequired
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'volunteer',
            ['/volunteer/form'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const { activeAction } = state.widget;
        const nextAction = getNextAction(
            state.widget.actions,
            activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );

        return {
            actionCompletedTime: getActionCompletedTime(state, 'volunteer'),
            actionIdentifier: activeAction.identifier,
            activeAction: state.widget.activeAction,
            apiRequestData: state.widget.apiRequestData,
            articleUrl: state.widget.articleUrl,
            bounceDismissed: state.widget.bounceDismissed,
            cards: state.widget.cards,
            currentFormValues: (state.form['volunteer'] || {}).values,
            isBackTransition: state.volunteer.isBackTransition,
            isMobileResolution: state.widget.isMobileResolution,
            isMultiCard:
                state.widget.cards[activeAction.order - 1].type ===
                CardTypes.multipleActions,
            isSubmitting: state.volunteer.isSubmitting,
            nextAction,
            skipEndCard: activeAction.skipEndCard,
            volunteerFormData: (state.form.volunteer || {}).values,
            volunteerOpportunity: state.volunteer.selectedVolunteerOpportunity,
            widgetRequestId: state.widget.widgetRequestId
        };
    },
    {
        cacheFormData,
        goBack,
        handleSkippingEndCard,
        onGoToNextCard,
        onSubmitVolunteerForm,
        setExitingCardProps,
        widgetBounce
    }
)(VolunteerDetails);
